module.exports = __webpack_public_path__ + "img/bottom-bg.7084cd11.svg";